import { TEXT_ALIGNMENT_CLASS_NAMES } from '@wix/communities-blog-client-common/dist/src/constants/text-alignment';

export const getHeaderTextAlignmentClassName = alignment => TEXT_ALIGNMENT_CLASS_NAMES[alignment];
